import { IAdminUser } from 'types';
import { EApiResponseStatus, IApiConResponse } from 'types/api';

export async function updateUsers<T extends IApiConResponse>(
  selectedUsersIds: string[],
  users: IAdminUser[],
  updateFunction: (user: IAdminUser) => Promise<T>,
): Promise<void> {
  const requests = selectedUsersIds.map((id) => {
    const user = users.find((user) => user.id === id);
    if (!user) throw new Error(`User with ID ${id} not found`);
    return updateFunction(user);
  });

  if (requests.length === 0) return;

  const responses = await Promise.all(requests);

  const failedResponse = responses.find((res) => res.status === EApiResponseStatus.FAILURE);
  if (failedResponse) throw new Error(failedResponse.error);
}

export const parseHashrateValueRange = (
  value: string,
): { fromValue: string | null; toValue: string | null } => {
  if (value === '0') return { fromValue: null, toValue: null };

  const numbers = value.match(/\d+/g);
  let fromValue: string | null = null;
  let toValue: string | null = null;

  if (numbers) {
    fromValue = value.startsWith('<') ? null : numbers[0];
    toValue = value.includes('<') ? numbers[numbers.length - 1] : null;

    if (value.startsWith('>') && !value.includes('<')) {
      fromValue = numbers[0];
      toValue = null;
    }
  }

  return { fromValue, toValue };
};
